export default "__VITE_ASSET__C46esxPg__";